import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import EcoSystemContentCard from "../../../../V2/Cards/EcoSystem/Content"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokEcoSystemContentCard = ({
  blok,
  mobileGridOrder,
  isSliderChild,
}: Storyblok.BlokProps<Storyblok.EcoSystemContentCard>) => {
  return (
    <EcoSystemContentCard
      isSliderChild={isSliderChild}
      mobileGridOrder={mobileGridOrder}
      primaryBackgroundColor={blok.primaryBackgroundColor}
      secondaryBackgroundColor={blok.secondaryBackgroundColor}
      textColor={blok.textColor}
      superscriptText={blok.superscriptText}
      titleText={blok.titleText}
      descriptionText={blok.descriptionText}
      superscriptTextColor={blok.superscriptTextColor}
      size={blok.size}
      videoUrl={storyblokLinkToYocoLink(blok.videoUrl)?.url ?? ""}
      imageUrl={blok.image.filename}
      imageAlt={blok.image.alt}
      imageRounded={blok.imageRounded}
      backgroundImage={blok.backgroundImage}
      buttonColor={blok.ctaColor}
      buttonLink={storyblokLinkToYocoLink(blok.ctaLink)}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokEcoSystemContentCard
